"use client";

import Link from "next/link";
import {ShoppingCart} from "lucide-react";
import { useInquiryCart } from "@/contexts/InquiryCartContext";

/** دکمه‌ی «سبد استعلام» در بالای هدر، همراه با شماره‌ی تعداد اقلام */
export default function BtnInquiryCart() {
    const { totalLines, hydrated } = useInquiryCart();
    const count = hydrated ? totalLines : 0;

    return (
        <Link
            href="/cart"
            title="سبد خرید"
            aria-label={`سبد، ${count} قلم`}
            className="flex items-center gap-2 rounded-lg border border-gray-300 p-2 text-gray-700 transition-colors hover:bg-gray-100 hover:text-primary"
        >
            <span
                className={`flex h-5 min-w-[20px] items-center justify-center rounded-full px-1.5 text-xs font-bold leading-none text-white ${
                    count > 0 ? "bg-red-500" : "bg-gray-400"
                }`}
            >
                {count.toLocaleString("fa-IR")}
            </span>
            <ShoppingCart className="h-5 w-5" />
            <span className="hidden text-sm -lg:block">سبد</span>
        </Link>
    );
}
